import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { ExistingCompanyLink, SourceCompanyId, ExternalCompany } from '../types'
import { useCompanyLinksStore } from './use-company-links'

export const useExternalCompaniesStore = defineStore(
  'externalCompanies',
  () => {
    const selectedCompanies = ref<ExternalCompany[]>([])

    function setSelectedCompanies(companyLinks: ExistingCompanyLink[]): void {
      if (!companyLinks.length) {
        return
      }
      const externalCompanies = companyLinks.map((link) => ({
        id: link.sourceCompanyId,
        name: link.sourceCompanyName,
        lastSyncedAt: link.lastSyncedAt,
      }))

      selectedCompanies.value = externalCompanies
    }

    function setSelectedCompaniesById(companyIds: SourceCompanyId[]): void {
      const existingCompanyLinks = useCompanyLinksStore().existingCompanyLinks
      const companyLinks = existingCompanyLinks.filter((link) =>
        companyIds.includes(link.sourceCompanyId)
      )
      if (!companyLinks.length) {
        return
      }
      setSelectedCompanies(companyLinks)
    }

    function clearSelectedCompanies(): void {
      selectedCompanies.value = []
    }

    const selectedCompany = computed(() => {
      return selectedCompanies?.value[0] || null
    })

    return {
      selectedCompanies,
      selectedCompany,
      setSelectedCompanies,
      setSelectedCompaniesById,
      clearSelectedCompanies,
    }
  }
)
